import { createFileRoute, redirect } from '@tanstack/react-router'
import { clientSessionQueryOptions } from '@/query/query-options'

/**
 * The session gate turned around, for the pages that only make sense signed
 * out: `/login` and `/o/$slug/login`. A person already signed in who reaches
 * one — most often with the browser's back button right after the sign-in —
 * goes home instead of meeting a form that asks for the organization they
 * are already in (OPSSTD-9014).
 *
 * `replace`, so the sign-in page leaves the history it was found in: a
 * second press of back goes past it instead of bouncing off it again.
 *
 * Same read as the `(private)` gate, so whichever runs first leaves the
 * session in the cache for the other, and `ssr: false` for the same reason
 * as there: the guard reads the browser's session.
 */
export const Route = createFileRoute('/(signed-out)')({
	ssr: false,
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.fetchQuery(
			clientSessionQueryOptions()
		)

		if (session.sessionType === 'authenticated') {
			throw redirect({ to: '/', replace: true })
		}
	}
})
